<template>
  <div>
    <!-- City Clinic Listing -->
    <CityListing v-if="pageType === 'city'" :cityData="cityData.data" />

    <!-- Clinic Detail -->
    <ClinicDetail v-else-if="pageType === 'clinic'" :clinicData="clinicData.data" />
  </div>
</template>

<script setup>
const CityListing = defineAsyncComponent(() => import("./components/city-listing.vue"));
const ClinicDetail = defineAsyncComponent(() => import("./components/detail-view.vue"));

const route = useRoute();

const fetchOrNull = async (fn) => {
  try {
    const response = await fn();
    return response?.data ? response : { data: ref(null) };
  } catch {
    return { data: ref(null) };
  }
};

const cityResult = await fetchOrNull(() => useCityDetailPage(route.params.slug));
const cityData = cityResult.data;

let clinicData = ref(null);
if (!cityData.value) {
  const clinicResult = await fetchOrNull(() => useFetchClinicDetailBySlug(route.params.slug));
  clinicData = clinicResult.data;
}

const pageType = computed(() => {
  if (cityData.value) return "city";
  if (clinicData.value) return "clinic";
  return null;
});

if (pageType.value === "city" && cityData.value) {
  await useMetaTitles(cityData.value.data, "city");
} else if (pageType.value === "clinic" && clinicData.value) {
  await useMetaTitles(clinicData.value.data, "clinic");
}

if (!pageType.value) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
    fatal: true,
  });
}
</script>

<style scoped></style>
